module.exports = __webpack_public_path__ + "img/EASL.7d29c036.jpg";